<template>
  <div class="border-1 mt-8 border-t border-grey-300 pt-4 md:mt-12 md:pt-6">
    <template v-if="!submitted">
      <p class="!mb-2 !text-base font-normal md:!text-lg">Was this helpful?</p>
      <div class="flex items-center gap-8">
        <button type="button" @click="handleSubmit('positive')">
          <IconSocialThumbsUp
            class="h-6 w-6 fill-green-800 hover:fill-green-500 active:fill-green-900 md:h-8 md:w-8"
          />
          <span class="sr-only">Yes, this was helpful.</span>
        </button>
        <button type="button" @click="handleSubmit('negative')">
          <IconSocialThumbsDown
            class="h-6 w-6 fill-green-800 hover:fill-green-500 active:fill-green-900 md:h-8 md:w-8"
          />
          <span class="sr-only">No, this was not helpful.</span>
        </button>
      </div>
    </template>
    <p v-else class="!mb-2 !text-base font-normal md:!text-lg">
      Thank you for your feedback.
    </p>
  </div>
</template>

<script setup lang="ts">
const { path } = useRoute();
const submitted = ref(false);

const handleSubmit = (SubmittedFeedback: string) => {
  submitted.value = true;

  const gtm = useGtm();
  gtm?.trackEvent({
    event: "GenericEvent",
    eventCategory: "feedback_module",
    eventAction: SubmittedFeedback,
    eventLabel: path ?? "unknown",
  });
};
</script>
